// extracted by mini-css-extract-plugin
export default {"mobile-cover-upload-card":"general_mobile-cover-upload-card__evjEj","sort-div":"general_sort-div__AGeRn"};